import { Alert } from '@ps/sports-ui-component-library';
import React from 'react';
import { useField } from 'react-final-form';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import Translation from '@swf/components/Translation/Translation';

import { isStakeError } from '../../../../../../../../utils/isStakeError';

import styles from './StakeError.scss';

const StakeError: React.FC<{ fieldName: string }> = ({ fieldName }) => {
  const {
    input,
    meta: { error, validating }
  } = useField(`${fieldName}.stakePerLine`);

  if (!error || validating || !isStakeError(error)) return null;

  const currencyValue = error.actionableValue ? (
    <button className={styles.button} onClick={() => input.onChange(error.value)} type="button">
      <CurrencyAmount value={error.value} dollarValue />
    </button>
  ) : (
    <CurrencyAmount value={error.value} dollarValue />
  );

  return (
    <Alert level="warning" variant="passive" className={styles.stakeError}>
      <div>
        <Translation
          {...error.translationTag}
          values={{
            0: currencyValue
          }}
        />
      </div>
    </Alert>
  );
};

export default StakeError;
